import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import useSWR, { type SWRConfiguration } from "swr";
import { config } from "@/config";
import type { GetQueries } from "@typings/api";
import { isEmpty } from "@utils/formatters";
import type { GetIndividualAttachmentsResponse } from "./type";

async function getIndividualAttachmentsById(
  individualId: string,
  query: GetQueries,
): Promise<GetIndividualAttachmentsResponse> {
  const params = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (isEmpty(value)) return;

    params.append(key, String(value));
  });

  let url = apiPaths.individuals.getAttachments(individualId);
  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const response = await apiClient.get<GetIndividualAttachmentsResponse>(url);

  return response.data;
}

export function useGetIndividualAttachments(
  individualId: string,
  query: GetQueries | null,
  options?: SWRConfiguration,
) {
  const mergedOptions: SWRConfiguration = {
    ...config.swr,
    ...options,
  };

  return useSWR(
    [
      `fetch-individual-attachments-${individualId}`,
      JSON.stringify(query ?? {}),
    ],
    () => getIndividualAttachmentsById(individualId, query ?? {}),
    mergedOptions,
  );
}
